import { useRef } from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

export default function FeedbackSplitter({ open, width, onResize, onToggle }: {
  open: boolean; width: number; onResize: (width: number) => void; onToggle: () => void;
}) {
  const dragging = useRef(false);
  return <div className="feedback-splitter">
    <div className="feedback-splitter-drag" role="separator" tabIndex={0}
      aria-label="Resize ticket chat" aria-orientation="vertical" aria-controls="feedback-ticket-chat"
      aria-valuemin={0} aria-valuemax={65} aria-valuenow={open ? Math.round(width) : 0}
      aria-valuetext={open ? `${Math.round(width)} percent` : 'Collapsed'}
      title="Drag to resize; drag left to collapse"
      onPointerDown={event => {
        if (event.button !== 0) return;
        event.preventDefault();
        event.currentTarget.focus();
        event.currentTarget.setPointerCapture(event.pointerId);
        dragging.current = true;
      }}
      onPointerMove={event => {
        if (!dragging.current) return;
        const bounds = event.currentTarget.parentElement?.parentElement?.getBoundingClientRect();
        if (bounds?.width) onResize((event.clientX - bounds.left) / bounds.width * 100);
      }}
      onPointerUp={event => { dragging.current = false; event.currentTarget.releasePointerCapture(event.pointerId); }}
      onPointerCancel={() => { dragging.current = false; }}
      onLostPointerCapture={() => { dragging.current = false; }}
      onKeyDown={event => {
        const current = open ? width : 0;
        if (event.key === 'ArrowLeft') onResize(current <= 22 ? 0 : current - 3);
        else if (event.key === 'ArrowRight') onResize(current === 0 ? 22 : current + 3);
        else if (event.key === 'Home') onResize(0);
        else if (event.key === 'End') onResize(65);
        else if (event.key === 'Enter') onToggle();
        else return;
        event.preventDefault();
      }} />
    <button type="button" className="feedback-splitter-toggle" aria-label={open ? 'Collapse ticket chat' : 'Expand ticket chat'} aria-expanded={open} aria-controls="feedback-ticket-chat" title={open ? 'Collapse ticket chat' : 'Expand ticket chat'} onClick={onToggle}>
      {open ? <ChevronLeft size={14} /> : <ChevronRight size={14} />}
    </button>
  </div>;
}
